var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Computing_",
    "data-name": "Computing ",
    transform: "translate(21156 -2354)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21156 2354)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_60",
    "data-name": "Union 60",
    d: "M12.053,51.435a3,3,0,0,1,0-6h4a2,2,0,0,1-2-2v-19a2,2,0,0,1,2-2h33a2,2,0,0,1,2,2v19a2,2,0,0,1-2,2h-25a3.006,3.006,0,0,0,3,3h11a3,3,0,0,0,3-3h12a3,3,0,0,1,0,6Zm4-26v17a1,1,0,0,0,1,1h31a1,1,0,0,0,1-1v-17a1,1,0,0,0-1-1h-31A1,1,0,0,0,16.052,25.434Zm12.889,14.43L33.3,27.011h1.748L30.689,39.864Zm7.3-4.39L40.965,33.8l-4.723-1.65V29.888l7.081,2.968v1.91l-7.081,2.976Zm-15.227-.707V32.848l7-2.968v2.277L23.38,33.824l4.634,1.634v2.277Zm34.043,2.25H52.553V24.434a3.5,3.5,0,0,0-3.5-3.5h-33a3.5,3.5,0,0,0-3.5,3.5V37.016h-5.3a9.054,9.054,0,0,1-3.583-.892,6.392,6.392,0,0,1-2.488-2.119A7.4,7.4,0,0,1,0,29.88,6.2,6.2,0,0,1,1.6,25.249a7.508,7.508,0,0,1,5.2-1.88c.282,0,.453.014.457.014s0,0,0-.012a22.94,22.94,0,0,1,.612-3.418,11.252,11.252,0,0,1,2.81-5.388c1.676-1.493,4.153-1.807,5.936-1.807a14.835,14.835,0,0,1,2.361.183s0,0,0-.009a17.1,17.1,0,0,1,.449-3.493,13.39,13.39,0,0,1,3.293-6.372A10.972,10.972,0,0,1,30.838,0l.319,0a12.834,12.834,0,0,1,7.183,2.12A11.941,11.941,0,0,1,42.15,6.558a17.012,17.012,0,0,1,1.77,6.382l.018,0c.4-.035.886-.054,1.364-.054,1.858,0,5.267.286,7.2,2.2a10.092,10.092,0,0,1,2.32,5.472,20.127,20.127,0,0,1,.232,3.4l.014,0a13.193,13.193,0,0,1,1.939-.138c1.767,0,4.2.332,5.776,1.918a5.9,5.9,0,0,1,1.553,4.372,6.13,6.13,0,0,1-3.406,5.848,11.567,11.567,0,0,1-5.062,1.085C55.372,37.046,55.061,37.017,55.058,37.016Z",
    transform: "translate(-21142.67 2372.565)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputing);
export default __webpack_public_path__ + "static/media/Computing.88dea5a0.svg";
export { ForwardRef as ReactComponent };